import { MortgagePurpose } from "../../../../types/common";
import { FF2Step, FormData } from "../types";

export const handleStartStep = (formData: FormData) => {
  let nextStep;

  switch (formData.mortgagePurpose) {
    case MortgagePurpose.Purchase:
      nextStep = FF2Step.Purchase;
      break;
    case MortgagePurpose.PurchaseToLet:
      nextStep = FF2Step.PurchaseToLet;
      break;
    case MortgagePurpose.Remo:
      nextStep = FF2Step.Remo;
      break;
    default:
      nextStep = FF2Step.Start;
  }

  return nextStep;
};
